import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MtnaFocusDirectivesModule, MtnaInlineEditorModule, MtnaTrackByPropertyPipeModule } from '@mtna/core-angular';
import { RdsGetFormArrayControlPipeModule } from '../core/pipes';
import { RdsColumnToggleComponent } from './column-toggle.component';
import { RdsDataDictionaryTableComponent } from './data-dictionary-table.component';
import { FilterColumnsPipe } from './filter-columns.pipe';
import { IsColumnSelectedPipe } from './is-column-selected.pipe';
import { IsSelectedPipe } from './is-selected.pipe';
import { UneditablePipe } from './uneditable.pipe';

@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatCheckboxModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatTableModule,
    MtnaFocusDirectivesModule,
    MtnaInlineEditorModule,
    MtnaTrackByPropertyPipeModule,
    RdsGetFormArrayControlPipeModule,
    ReactiveFormsModule,
  ],
  declarations: [
    RdsDataDictionaryTableComponent,
    RdsColumnToggleComponent,
    FilterColumnsPipe,
    IsSelectedPipe,
    IsColumnSelectedPipe,
    UneditablePipe,
  ],
  exports: [RdsDataDictionaryTableComponent, RdsColumnToggleComponent],
})
export class RdsDataDictionaryTableModule {}

export * from './column-toggle.component';
export * from './column.model';
export * from './data-dictionary-table.component';
export * from './defaults.model';
export * from './toggle-event.model';
